const Body = ({ children, ...props }) => (
  <tbody className="divide-y divide-gray-200 bg-white" {...props}>{children}</tbody>
)

export default Body
